import React from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { getIn } from "formik";

export function InputSelect({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  size = "small",
  variant = "outlined",
  options,
  isLoading,
  getOptionLabel,
  isOptionEqualToValue,
  multiple,
  ...props
}) {
  return (
    <Autocomplete
      {...field}
      {...props}
      id={field.name}
      name={field.name}
      multiple={multiple}
      value={field.value}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionLabel={getOptionLabel}
      options={options}
      loading={isLoading}
      filterSelectedOptions
      onBlur={handleBlur}
      onChange={(event, newValue) => {
        setFieldValue(field.name, newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          type={type}
          name={field.name}
          label={label}
          variant={variant}
          onBlur={handleBlur}
          helperText={getIn(touched, field.name) && getIn(errors, field.name)}
          error={Boolean(
            getIn(touched, field.name) && getIn(errors, field.name)
          )}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
